module.exports = __webpack_public_path__ + "img/cut_sx3.2b790932.png";